import angular from 'angular'
import beatsService from './beats.service'

angular.module('ellipsis.beats', []).service('beatsService', beatsService)
